// constants of environment variables (found in .env.%environment% files in app root)
export const VITE_ENV_STAGING = 'staging';
export const VITE_ENV_PRODUCTION = 'production';
export const VITE_ENV_DEVELOPMENT = 'development';
export const VITE_ENV_REVIEW = 'review';
export const VITE_ENVS = [VITE_ENV_STAGING, VITE_ENV_PRODUCTION, VITE_ENV_DEVELOPMENT, VITE_ENV_REVIEW];

// Colors used to make the current environment recognisable at a glance (top border of the app).
export const ENVIRONMENT_COLORS = Object.freeze({
  [VITE_ENV_DEVELOPMENT]: '#3c8dbc', // blue
  [VITE_ENV_STAGING]: '#fdde3f', // yellow
  [VITE_ENV_REVIEW]: '#fe8421', // orange
  [VITE_ENV_PRODUCTION]: '#0a6553', // green (brand)
});

// Per-environment favicons, so the browser tab also makes the environment obvious.
export const ENVIRONMENT_FAVICONS = Object.freeze({
  [VITE_ENV_DEVELOPMENT]: '/static/favicon-development.ico', // blue
  [VITE_ENV_STAGING]: '/static/favicon-staging.ico', // yellow
  [VITE_ENV_REVIEW]: '/static/favicon-staging.ico', // yellow
  [VITE_ENV_PRODUCTION]: '/static/favicon.ico', // green (brand)
});

export const LOGIN_PAGE_NOTIFICATIONS = Object.freeze({
  ERROR_SESSION_EXPIRED: 'error_session_expired',
  ERROR_NO_ACCESS: 'error_no_access',
  SUCCESS_LOGOUT: 'success_logout',
});

export const SIDEBAR_TYPE_NOTIFICATIONS = 'notifications';

export const MAX_FILE_SIZE_IMAGE = '5000000'; // 5MB
